import { ThemeEvents } from '@theme/events';

const SELECTOR = '.product-form-buttons__go-to-cart';

/** @param {number} itemCount */
function updateGoToCartLinks(itemCount) {
  document.querySelectorAll(SELECTOR).forEach((link) => {
    link.setAttribute('aria-disabled', itemCount === 0 ? 'true' : 'false');
  });
}

document.addEventListener(ThemeEvents.cartUpdate, (event) => {
  const itemCount = event.detail.resource?.item_count;
  if (itemCount === undefined) return;

  updateGoToCartLinks(itemCount);
});

document.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest(SELECTOR) : null;
  if (link && link.getAttribute('aria-disabled') === 'true') {
    event.preventDefault();
  }
});
